import { useState, useEffect } from 'react'
import { matchPath, withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { flowRight } from 'lodash'

/* global window */

const Zendesk = ({ match }) => {
    const [initialized, setInitialized] = useState(!!window.$zopim)

    useEffect(() => {
        if (initialized) return

        const interval = setInterval(() => {
            if (window.$zopim) {
                clearInterval(interval)
                setInitialized(true)
            }
        }, 500)

        return () => clearInterval(interval)
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!initialized) return

        const $zopim = window.$zopim

        const hide = matchPath(match.path, {
            path: '/:lang(en)?/ajoneuvo/:vehicleId',
            exact: false,
            strict: false,
        })

        if (hide) {
            $zopim && $zopim.livechat && $zopim.livechat.hideAll()
        } else {
            $zopim && $zopim.livechat && $zopim.livechat.button.show()
        }
    }, [match.path, initialized])

    return null
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(Zendesk)
